import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { apiUrl, baseUrl } from "../../../utils/apis";
import { FaqResponse, SpecializationsApiItem, SpecializationsPayload } from "./types";



export const specializationsApiFetching = createApi({
    reducerPath: "specializationsApi",
    baseQuery: fetchBaseQuery({
        baseUrl,

        prepareHeaders: (headers) => {
            const token = sessionStorage.getItem("token");

            headers.set("Content-Type", "application/json");

            if (token) {
                headers.set("Authorization", `Bearer ${token}`);
            }

            return headers;

        },
    }),
    tagTypes: ["specialization"],

    endpoints: (builder) => ({
        getSpecializationList: builder.query<FaqResponse, void>({
            query: () => ({
                url: apiUrl.specializations,
                method: "GET",
                providesTags: ["specialization"],

            }),

        }),

        postSpecialization: builder.mutation({
            query: (bodyData: SpecializationsPayload) => ({
                url: apiUrl.specializations,
                method: "POST",
                body: bodyData,
            }),
            invalidatesTags: ["specialization"],
        }),
        updateSpecialization: builder.mutation<SpecializationsApiItem, { id: number | string; data: Partial<SpecializationsApiItem>, }>({
            query: ({ id, data }) => ({
                url: `${apiUrl.specializations}${id}/`,
                method: "PUT",
                body: data,
            }),
            invalidatesTags: ["specialization"],
        }),
        deleteSpecialization: builder.mutation<{ success: boolean; message: string }, number>({
            query: (id) => ({
                url: `${apiUrl.specializations}${id}/`,
                method: "DELETE",
            }),
            invalidatesTags: ["specialization"], 
        }),
    }),
});

export const { useGetSpecializationListQuery,useDeleteSpecializationMutation,usePostSpecializationMutation,useUpdateSpecializationMutation} = specializationsApiFetching;






